
import React, { useState } from "react";
import Accordion from "../Accordion";
   

const initialTerms = {
  comm1: { label: "Payment within 30 days", enabled: false, text: "" },
  comm2: { label: "Price fixed for 6 months", enabled: false, text: "" },
  del1: { label: "Delivery within 7 days", enabled: false, text: "" },
  del2: { label: "Quality as per standards", enabled: false, text: "" },
  legal1: { label: "Subject to local jurisdiction", enabled: false, text: "" },
};

const Page4 = ({ setPage }) => {
  const [terms, setTerms] = useState(initialTerms);
  const [isCommercialTermsOpen, setIsCommercialTermsOpen] = useState(true);
  const [isDeliveryTermsOpen, setIsDeliveryTermsOpen] = useState(false);
  const [isLegalTermsOpen, setIsLegalTermsOpen] = useState(false);

  const handleTermChange = (key, field, value) => {
    setTerms((prev) => ({
      ...prev,
      [key]: { ...prev[key], [field]: value },
    }));
  };

  const renderTerm = (key, label) => (
    <div key={key}>
      <div className="flex items-center space-x-3">
        <input
          type="checkbox"
          id={`check-${key}`}
          checked={terms[key].enabled}
          onChange={(e) => handleTermChange(key, "enabled", e.target.checked)}
          className="h-4 w-4 text-indigo-600 border-gray-300 rounded"
        />
        <label
          htmlFor={`check-${key}`}
          className="block text-sm font-medium text-gray-700"
        >
          {label}
        </label>
      </div>
      {terms[key].enabled && (
        <textarea
          id={key}
          name={key}
          value={terms[key].text}
          onChange={(e) => handleTermChange(key, "text", e.target.value)}
          rows="3"
          className="w-full p-2 mt-2 border border-gray-300 rounded-md shadow-sm"
        ></textarea>
      )}
    </div>
  );

  return (
    <>
      <h1 className="text-2xl sm:text-3xl font-bold text-gray-800 border-b pb-4">
        Terms & Conditions (Step 4/5)
      </h1>

      <div className="space-y-4">
        {/* Commercial Terms */}
        <Accordion
          title="Commercial Terms"
          isOpen={isCommercialTermsOpen}
          setIsOpen={setIsCommercialTermsOpen}
        >
          <div className="space-y-4">
            {Object.entries(initialTerms)
              .slice(0, 2)
              .map(([key, { label }]) => renderTerm(key, label))}
          </div>
        </Accordion>

        {/* Delivery & Quality Terms */}
        <Accordion
          title="Delivery & Quality Terms"
          isOpen={isDeliveryTermsOpen}
          setIsOpen={setIsDeliveryTermsOpen}
        >
          <div className="space-y-4">
            {Object.entries(initialTerms)
              .slice(2, 4)
              .map(([key, { label }]) => renderTerm(key, label))}
          </div>
        </Accordion>

        {/* Legal & General Terms */}
        <Accordion
          title="Legal & General Terms"
          isOpen={isLegalTermsOpen}
          setIsOpen={setIsLegalTermsOpen}
        >
          <div className="space-y-4">
            {Object.entries(initialTerms)
              .slice(4)
              .map(([key, { label }]) => renderTerm(key, label))}
          </div>
        </Accordion>
      </div>

      {/* Navigation */}
      <div className="flex justify-between pt-4 border-t mt-6">
        <button
          onClick={() => setPage(3)}
          className="px-6 py-2 bg-gray-600 text-white rounded"
        >
          Back
        </button>
        <button
          onClick={() => setPage(5)}
          className="px-6 py-2 bg-indigo-600 text-white rounded"
        >
          Next
        </button>
      </div>
    </>
  );
};

export default Page4;


// import React from 'react';

// const Page4 = () => {
//     const renderTerm = (key, label) => (
//       <div key={key}>
//         <div className="flex items-center space-x-3">
//           <input type="checkbox" id={`check-${key}`} checked={terms[key].enabled} onChange={(e) => handleTermChange(key, 'enabled', e.target.checked)} className="h-4 w-4 text-indigo-600 border-gray-300 rounded" />
//           <label htmlFor={`check-${key}`} className="block text-sm font-medium text-gray-700">{label}</label>
//         </div>
//         {terms[key].enabled && (
//           <textarea id={key} name={key} value={terms[key].text} onChange={(e) => handleTermChange(key, 'text', e.target.value)} rows="3" className="w-full p-2 mt-2 border border-gray-300 rounded-md shadow-sm"></textarea>
//         )}
//       </div>
//     );

//     return (
//       <>
//         <h1 className="text-2xl sm:text-3xl font-bold text-gray-800 border-b pb-4">Terms & Conditions (Step 4/5)</h1>
//         <div className="space-y-4">
//           <Accordion title="Commercial Terms" isOpen={isCommercialTermsOpen} setIsOpen={setIsCommercialTermsOpen}>
//             <div className="space-y-4">
//               {Object.entries(initialTerms).slice(0, 6).map(([key, { label }]) => renderTerm(key, label))}
//             </div>
//           </Accordion>
//           <Accordion title="Delivery & Quality Terms" isOpen={isDeliveryTermsOpen} setIsOpen={setIsDeliveryTermsOpen}>
//             <div className="space-y-4">
//               {Object.entries(initialTerms).slice(6, 14).map(([key, { label }]) => renderTerm(key, label))}
//             </div>
//           </Accordion>
//           <Accordion title="Legal & General Terms" isOpen={isLegalTermsOpen} setIsOpen={setIsLegalTermsOpen}>
//             <div className="space-y-4">
//               {Object.entries(initialTerms).slice(14).map(([key, { label }]) => renderTerm(key, label))}
//             </div>
//           </Accordion>
//         </div>
//         <div className="flex justify-between pt-4 border-t mt-6">
//           <button onClick={() => setPage(3)} className="px-6 py-2 bg-gray-600 text-white rounded">Back</button>
//           <button onClick={() => setPage(5)} className="px-6 py-2 bg-indigo-600 text-white rounded">Next</button>
//         </div>
//       </>
//     );
//   };

// export default Page4;
